import React from 'react'
import {AsyncFeature} from '@modifi/code-splitting'

import {FullScreenLoader} from '@modifi/ui'

import {URL_PATH_TRANSACTION_DETAILS, URL_PATH_TRANSACTION_LIST} from './constants'

const loader = props => <FullScreenLoader {...props} />

export default [
  {
    path: '/',
    redirectTo: URL_PATH_TRANSACTION_LIST,
  },
  {
    path: URL_PATH_TRANSACTION_LIST,
    component: AsyncFeature({
      loader,
      importThunk: () =>
        import(/* webpackChunkName:"transactions-feature" */ '../features/transactions'),
      componentName: 'TransactionList',
    }),
  },
  {
    path: URL_PATH_TRANSACTION_DETAILS,
    component: AsyncFeature({
      loader,
      importThunk: () =>
        import(/* webpackChunkName:"transactions-feature" */ '../features/transaction-details'),
      componentName: 'TransactionDetails',
    }),
  },
]
